import {
  TimeOffRequestApproverFormValue,
  TimeOffRequestDateRangeValue,
  TimeOffRequestDayFormValues,
} from './time-off-request-day-schema';

/**
 * Field-name constants for the request form. One set is shared across all three
 * modes (read, approve, create) so the single form component and the page bind
 * to the same paths regardless of mode.
 */
export const TIME_OFF_FIELD_CATEGORY = 'timeOffTypeId';
export const TIME_OFF_FIELD_DATE_RANGE = 'dateRange';
export const TIME_OFF_FIELD_DAYS = 'days';
export const TIME_OFF_FIELD_APPROVERS = 'approvers';
export const TIME_OFF_FIELD_DESCRIPTION = 'description';
export const TIME_OFF_FIELD_APPROVAL_REQUIRED = 'approvalRequired';

/**
 * Unified form model backing the request screen in every mode. Read/approve
 * hydrate it from the fetched details (and never validate/submit); create
 * builds it from scratch under the create Zod schema. Keeping one shape lets a
 * single form component and page serve all modes.
 */
export interface TimeOffRequestFormValues {
  timeOffTypeId: string;
  dateRange: TimeOffRequestDateRangeValue | null;
  days: TimeOffRequestDayFormValues[];
  approvers: TimeOffRequestApproverFormValue[];
  description: string;
  /** From the selected type's policy — when false, approvers aren't required. */
  approvalRequired: boolean;
}
